import Modal from "../../layout/Modal";
import QueueModalYoutube from "./modal/QueueModalYoutube";
import QueueModalText from "./modal/QueueModalText";
import QueueModalLink from "./modal/QueueModalLink";
import QueueModalImage from "./modal/QueueModalImage";
import QueueModalVideo from "./modal/QueueModalVideo";
import QueueModalPintrest from "@/components/Queue/modal/QueueModalPintrest";
import QueueModalGiphy from "@/components/Queue/modal/QueueModalGiphy";

export interface QueueModalsProps {
    isOpen: boolean;
    onClose: () => void;
    setIsOpen: (value: string) => void;
    type: string;
    requestRefresh?: () => void;
}

const buildQueueModalsByType = (type: string, setIsOpen: (value: any) => void, requestRefresh?: () => void) => {
   switch (type) {
       case 'pintrest':
           return <QueueModalPintrest requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>
       case 'youtube':
           return <QueueModalYoutube requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       case 'giphy':
           return <QueueModalGiphy requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       case 'text':
           return <QueueModalText requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       case 'link':
           return <QueueModalLink requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       case 'image':
           return <QueueModalImage requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       case 'video':
           return <QueueModalVideo requestRefresh={requestRefresh} setIsOpen={setIsOpen}/>;
       default:
           return 'who knows';
   }
}

export default function QueueModals({isOpen, setIsOpen, onClose, type, requestRefresh}: QueueModalsProps) {
    return (
        <Modal className="w-full sm:w-auto" hideCloseButton={true} hasTransparentBackground={true} isOpen={isOpen} onClose={onClose}>
            {buildQueueModalsByType(type, setIsOpen, requestRefresh)}
        </Modal>
    );
}